import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';
import View from '../view';

interface ITabPaneProps {
  id?: string;
  activeKey?: string;
  key: string;
  tab: string;
}

const TabPane: FC<PropsWithChildren<ITabPaneProps>> = ({ children, id, activeKey }) => {
  const rootClass = classNames('ink-tabs__pane', { 'ink-tabs__pane--inactive': id !== activeKey });
  return <View className={rootClass}>{children}</View>;
};

export default TabPane;
